import React, {useEffect, useState, useReducer} from 'react'
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import PriceFormat from "react-number-format";

import MaterialTable from "material-table"
import { Paper } from "@material-ui/core"
import { Chip } from "@material-ui/core"
import { Grid } from '@material-ui/core'
import { Tooltip } from '@material-ui/core'
import { List } from '@material-ui/core'
import { ListItem } from '@material-ui/core'
import { ListItemText } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'

import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'


import {green, red, blue, grey} from '@material-ui/core/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {faSearch, faShoppingCart} from '@fortawesome/free-solid-svg-icons'
import { faSortUp } from "@fortawesome/free-solid-svg-icons"
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons'
import { faList } from '@fortawesome/free-solid-svg-icons'

import { _t } from '../../../i18n/lang'
import  { MaterialTableLocaleDelayed } from '../../../i18n/material-table'

import { abortController, projectPricesServices } from "../../../services/projectPricesServices";
import Filter from './Filter'
import Cart from './../cart/Cart'
import CartReducer from '../cart/Reducer'
import {cartConstants} from "../../../constants/cartConstants";

const tableIcons = {
    NextPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleRight} { ...props }  /> ),
    PreviousPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleLeft} { ...props } /> ),
    FirstPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleDoubleLeft} { ...props } /> ),
    LastPage: React.forwardRef( (props, ref) => <FontAwesomeIcon icon={faAngleDoubleRight} { ...props } /> ),
    Search: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faSearch} { ...props } /> ),
    SortArrow: React.forwardRef((props, ref) => <FontAwesomeIcon { ...props } icon={faSortUp} /> ),
    ResetSearch: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faTimes} { ...props } size='xs' /> ),
    Filter: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faFilter} { ...props } /> ),
};


const useStyles = makeStyles((theme) => ({
    wrap: {
        flexGrow: 1,
        paddingRight: '1em',
        paddingLeft: '1em',
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    tableHeader: {
        color: 'rgba(0, 0, 0, .54)',
        marginBottom: '1em'
    },
    iconColor: {
        color: '#fff'
    },
    fabStyle: {
        marginRight: '1em',
        backgroundColor: '#cb0101'
    },
    headerColor: {
        color: '#cb0101',
    }
}));

const statusColor = (status) => {
    if (status === 'INACTIVE') {
        return red[500]
    }
    if (status === 'ACTIVE') {
        return green[500]
    }
    return 'blueGrey'
}

export default function CanonProducts(props) {
    const [products, setProducts] = useState([])
    const [ordersFeatures, setOrdersFeatures] = useState([])
    const [eurExchangeRate, setEurExchangeRate] = useState(1)
    const [cart, setCart] = useReducer(CartReducer, { cart: new Map()})
    const [loading, setLoading] = useState(true)
    const [cartLoading, setCartLoading] = useState(false)
    const [alert, setAlert] = useState({open: false, message: '', type: 'success', duration:  6000})

    const { vendor } = useParams();

    const [filters, setFilters] = useState({
        phrase: '',
        startFrom: null,
        startTo: null,
        expireFrom: null,
        expireTo: null,
    })

    useEffect( () => {
        const abortController = new AbortController()
        async function fetchData() {
            setLoading(true)
            const result = await projectPricesServices.products(vendor, abortController)
            if (!result) {
                return
            }
            const { products, eurExchangeRate, ordersFeatures } = result
            setOrdersFeatures(ordersFeatures)
            setProducts(products)
            setEurExchangeRate(eurExchangeRate)
            setLoading(false)
        }

        async function fetchCart() {
            setCartLoading(true)
            const response = await projectPricesServices.cart(abortController)

            if (!response) {
                setCartLoading(false)
                return
            }
            const contents = JSON.parse(response['content'])

            if (!contents) {
                setCartLoading(false)
                return
            }

            contents.forEach((content) => {
                const projectData = {
                    id: content.id,
                    projectId: content.projectId,
                    projectNumber: content.projectNumber,
                    projectCustomerId: content.projectCustomerId,
                    vendorId: content.vendorId,
                    vendor: content.vendor,
                    client: content.client,
                }

                addProjectToCart(projectData, content.details, content.features)
            })
            setCartLoading(false)
        }

        fetchData()
        fetchCart()

        document.addEventListener("visibilitychange", function() {
            if (!document.hidden) {
                 fetchData();
            }
        });

        return () => abortController.abort()
    }, [vendor])

    const showAlert = (type, message, duration = 6000) => {
        setAlert({
            open: true,
            message,
            type,
            duration
        })
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlert({
            open: false,
            message: '',
            type: 'success'
        })
    };

    const classes = useStyles();

    const styleCss = {
        fontSize: '10px'
    }

    const columns = [
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_PART'),
            field: 'part',
            render(rowData) {
                return <label style={styleCss}>{rowData.part}</label>
            }

        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_VEND_NO'),
            field: 'vendorPartNumber',
            render(rowData) {
                return <label style={styleCss}>{rowData.vendorPartNumber}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_GOODS_NAME'),
            field: 'productName',
            render(rowData) {
                return <label style={styleCss}>{rowData.productName}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_PROJECT_NO'),
            field: 'projectNo',
            render(rowData) {
                return <label style={styleCss}>{rowData.projectNo}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_CLIENT'),
            field: 'client',
            render(rowData) {
                return <label style={styleCss}>{rowData.client}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_RESELLER'),
            field: 'resellerName',
            render(rowData) {
                return <div>
                    <label style={styleCss}>{rowData.resellerName}</label>
                    <label style={styleCss}><i>({rowData.resellerMfgId})</i></label>
                </div>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_STATUS'),
            field: 'status',
            cellStyle: {textAlign: 'center'},
            headerStyle: {
                textAlign: 'center',
            },
            render(rowData) {
                return <Chip
                    style={{backgroundColor: statusColor(rowData.status)}}
                    label={_t(`PROJECT_PRICES_STATUS_${rowData.status}`)}
                    size='small'
                />
            }
        },
        {
            title: _t('PROJECT_TABLE_HEAD_START_AT'),
            field: 'startAt',
            type: 'date',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'center'},
        },
        {
            title: _t('PROJECT_TABLE_HEAD_EXPIRE_AT'),
            field: 'expireAt',
            type: 'date',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'center'},

        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_PRICE'),
            field: 'price',
            type: 'numeric',
            render(rowData) {
                return (
                    <>
                        <PriceFormat
                            decimalSeparator='.'
                            thousandSeparator={`\u00a0`}
                            fixedDecimalScale={true}
                            decimalScale={2}
                            value={rowData.price}
                            displayType={'text'}
                        />{`\u00a0${rowData.currency}`}
                    </>
                )
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_MAX_QTY'),
            field: 'maxQty',
            type: 'numeric',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                return (
                    <>
                        <small style={{ margin: '0 2px' }}>
                            {_t('PROJECT_DETAILS_MAX_QTY')}
                            {rowData.maxQty} {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                        </small>
                        <br/>
                        <small style={{ margin: '0 2px' }}>
                            {_t('PROJECT_DETAILS_MONTH_LIMIT')}
                            {rowData.maxQtyPerMonth
                                ? (
                                    <>
                                        {rowData.maxQtyPerMonth} {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                                    </>
                                ) : (
                                    <>
                                        <i style={{marginLeft: '2px'}}>{_t('PROJECT_DETAILS_DATA_NOT_SET')}</i>
                                    </>
                                )}

                        </small>
                        <br/>
                        <small style={{margin: '0 2px', color: green[500]}}>
                            {_t('PROJECT_DETAILS_AV_BY_THE_END_OF_MONTH')}
                            {rowData.availableByTheEndOfTheMonth
                                ? (
                                    <>
                                        {rowData.availableByTheEndOfTheMonth} {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                                    </>
                                ) : (
                                    <>
                                        <i style={{marginLeft: '2px'}}>{_t('PROJECT_DETAILS_DATA_NOT_SET')}</i>
                                    </>
                                )}
                        </small>
                    </>
                )
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_LEFT_QTY'),
            field: 'leftQty',
            type: 'numeric',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
            render(rowData) {
                const { onStock, reservedQty, leftQty } = rowData
                return (
                    <>
                        {leftQty}

                        {reservedQty !== 0 && (
                            <Tooltip title={_t('CANON_PRODUCT_TABLE_HEAD_QTY_IN_RESERVATION')}  placement="top">
                                <span style={{margin: '0 2px', color: '#aaa', cursor: 'pointer'}}>({reservedQty})</span>
                            </Tooltip>

                        )}
                        {onStock !== 0 && (
                            <>
                                <br/>
                                <small style={{margin: '0 2px', color: green[500]}}>
                                    {_t('PROJECT_DETAILS_ON_STOCK')}
                                    {onStock < 0 ?  0 : onStock}
                                    {_t('PROJECT_DETAILS_ON_STOCK_PCS')}
                                </small>
                            </>
                        )}
                    </>
                )
            }
        },
    ]

    const filterByPhrase = (row) => {
        const { projectNo, part, vendorPartNumber, productName, client, resellerName, resellerMfgId } = row
        return projectNo.toLowerCase().includes(filters.phrase.toLowerCase())
            || part.toLowerCase().includes(filters.phrase.toLowerCase())
            || vendorPartNumber.toLowerCase().includes(filters.phrase.toLowerCase())
            || productName.toLowerCase().includes(filters.phrase.toLowerCase())
            || client.toLowerCase().includes((filters.phrase.toLowerCase()))
            || resellerName.toLowerCase().includes((filters.phrase.toLowerCase()))
            || resellerMfgId.toLowerCase().includes((filters.phrase.toLowerCase()))
    }

    const filterByStartFrom = (row) => {

        if (!filters.startFrom) {
            return row
        }

        const rowStartFrom = new Date(`${row.startAt}`)
        const { startFrom } = filters
        const filterStart = new Date(
            startFrom.getFullYear(),
            startFrom.getUTCMonth(),
            startFrom.getDate(),
            0,
            0,
            0
        )

        return rowStartFrom >= filterStart
    }

    const filterByStartTo = (row) => {
        if (!filters.startTo) {
            return row
        }

        const rowStartTo = new Date(`${row.startAt}`)
        const { startTo } = filters
        const filterStart = new Date(
            startTo.getFullYear(),
            startTo.getUTCMonth(),
            startTo.getDate(),
            23,
            59,
            59
        )

        return rowStartTo <= filterStart
    }

    const filterByExpireFrom = (row) => {

        if (!filters.expireFrom) {
            return row
        }

        const rowExpireFrom = new Date(`${row.expireAt}`)
        const { expireFrom } = filters
        const filterExpire = new Date(
            expireFrom.getFullYear(),
            expireFrom.getUTCMonth(),
            expireFrom.getDate(),
            0,
            0,
            0
        )

        return rowExpireFrom >= filterExpire
    }

    const filterByExpireTo = (row) => {
        if (!filters.expireTo) {
            return row
        }

        const rowExpireTo = new Date(`${row.expireAt}`)
        const { expireTo } = filters
        const filterExpire = new Date(
            expireTo.getFullYear(),
            expireTo.getUTCMonth(),
            expireTo.getDate(),
            23,
            59,
            59
        )

        return rowExpireTo <= filterExpire
    }

    const filteredData = products
        .filter(filterByPhrase)
        .filter(filterByStartFrom)
        .filter(filterByStartTo)
        .filter(filterByExpireFrom)
        .filter(filterByExpireTo)


    const addProjectToCart = (projectData, details, features) => {
        const payload = {
            ...projectData,
            details,
            features,
            fetchData: 1,
        }
        setCart({type: cartConstants.ADD, payload})
    }

    const removeProjectFromCart = (project) => {
        setCart({type: cartConstants.REMOVE, payload: project})
        updateCart()
    }

    const addProjectDetails = (id, details) => {
        setCart({type:  cartConstants.ADD_DETAILS, payload: {id, details}})
        updateCart()
    }

    const editProjectDetailQty = (id, part, qty, withoutUpdateCart = 0) => {
        setCart({type: cartConstants.EDIT_DETAIL, payload: {id, part, qty}})
        if (!withoutUpdateCart) {
            updateCart()
        }
    }

    const removeDetailFromProject = (id, part) => {
        setCart({type: cartConstants.REMOVE_DETAIL, payload: {id, part}})
        updateCart()
    }

    const editProjectDetailVendorIdentifier = (id, part, vendorIdentifier) => {
        setCart({type: cartConstants.EDIT_DETAIL_VENDOR_IDENTIFIER, payload: {id, part, vendorIdentifier}})
        updateCart()
    }

    const addDetail = (detail, features) => {
        setCart({type: cartConstants.ADD_DETAIL, payload: { detail, features }})
        updateCart()
    }

    const editProjectFeature = (id, feature) => {
        setCart({ type: cartConstants.EDIT_PROJECT_FEATURE, payload: { id, feature } });
        updateCart()
    }

    const resetCart =() => {
        setCart({type: 'clear'})
        updateCart()
    }

    const updateCart = async () => {
        if (!cart) {
            return
        }

        let temp = []
        for (const item of cart.cart.entries()) {
            temp.push(item[1])
        }

        await projectPricesServices.updateCart(temp)
    }

    const loadCart2AB = async () => {
        if (!cart) {
            return
        }
        setCartLoading(true)
        const result = await projectPricesServices.loadCart2AB(cart.cart.entries())
        resetCart()
        showAlert(result.type, result.message)

        setLoading(true)
        const abortController = new AbortController()
        const { products, eurExchangeRate } = await projectPricesServices.products(vendor, abortController)
        setProducts(products)
        setEurExchangeRate(eurExchangeRate)
        setLoading(false)

        setCartLoading(false)
    }

    const productInCart = (projectId, part) => {
        if (!cart.cart.has(projectId)) {
            return false
        }
        const found = cart.cart.get(projectId).details.filter((row) => row.part === part)
        return found.length > 0
    }

    const displayTitle = () => {
        return (
            <h1 className={ classes.headerColor } style={{ marginBottom: '1em', paddingLeft: '10px' }}>
                <Fab size="medium" aria-label="cart" className={classes.fabStyle}>
                    <FontAwesomeIcon icon={faList} className={classes.iconColor}/>
                </Fab>
                {_t("CANON_HEADER_PRODUCTS")}
            </h1>
        )
    }

    let alertBorderColor = '#28a745'

    if (alert.type === 'info') {
        alertBorderColor = '#2196f3'
    }

    if (alert.type === 'warning') {
        alertBorderColor = '#ff9800'
    }

    return (
        <div className={classes.wrap}>
            <Snackbar open={alert.open}
                      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                      autoHideDuration={alert.duration}
                      onClose={closeAlert}
                      style={{border: `1px solid ${alertBorderColor}`}}
            >
                <Alert
                    onClose={closeAlert}
                    severity={alert.type}
                >
                    <div dangerouslySetInnerHTML={{__html: alert.message}} />
                </Alert>
            </Snackbar>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <MaterialTable
                            className={classes.root}
                            disableGutters={true}
                            columns={columns}
                            data={filteredData}
                            isLoading={loading}
                            title={displayTitle()}
                            localization={MaterialTableLocaleDelayed()}
                            options={{
                                showTitle: true,
                                search: true,
                                draggable: false,
                                actionsColumnIndex: -1,
                                pageSizeOptions: [5, 10, 20, 50, 100],
                                headerStyle: {
                                    backgroundColor: '#33323a',
                                    color: '#fff',
                                    '& span': {
                                        color: 'red'
                                    }
                                },
                            }}
                            actions={[
                                rowData => {
                                    const leftQty = parseInt(rowData.leftQty, 10);
                                    let tooltip = _t('PRODUCT_ADD_TO_CART')
                                    const isDisabled = leftQty < 1 || rowData.status !== 'ACTIVE'
                                    if (isDisabled) {
                                        tooltip = _t('PRODUCT_NOT_ALLOWED_TO_ADD_TO_CART')
                                    }

                                    const inCart = productInCart(rowData.projectId, rowData.part)

                                    return ({
                                        icon() {
                                            if (isDisabled) {
                                                return <FontAwesomeIcon style={{color: grey[500]}} icon={faPlusSquare} size='xs' />
                                            }
                                            if (inCart) {
                                                return <FontAwesomeIcon style={{color: green[500]}} icon={faPlusSquare} size='xs' />
                                            }
                                            return <FontAwesomeIcon style={{color: blue[500]}} icon={faPlusSquare} size='xs' />
                                        },
                                        onClick: (event, rowData) => {
                                            if (isDisabled) {
                                                return
                                            }

                                            if (inCart) {
                                                const alertMessage =  _t("CANON_ALERT_PRODUCT_ALREADY_CART_1")
                                                    + ` <i>${rowData.productName} (${rowData.part})</i> `
                                                    +  _t("CANON_ALERT_PRODUCT_ALREADY_CART_2")
                                                showAlert("warning", alertMessage, 2000)
                                                return
                                            }
                                            const features = ordersFeatures.filter(
                                                orderFeature => orderFeature.projectId === rowData.projectId
                                            )

                                            addDetail(rowData, features)

                                            const alertMessage =  _t("CANON_ALERT_PRODUCT_ADD_TO_CART_1")
                                                + ` <i>${rowData.productName} (${rowData.part})</i> `
                                                +  _t("CANON_ALERT_PRODUCT_ADD_TO_CART_2")
                                            showAlert(
                                                "info",
                                                alertMessage,
                                                2000
                                            )
                                        },
                                        tooltip
                                    }
                                )}
                            ]}
                            icons={tableIcons}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={5}>
                    <Paper className={classes.paper} style={{
                        minHeight: '12em',
                        position: "relative",
                        paddingBottom: '3em',
                    }}>
                        <Cart
                            cart={cart.cart}
                            removeProjectFromCart={removeProjectFromCart}
                            loadCart2AB={loadCart2AB}
                            isLoading={cartLoading}
                            addProjectDetails={addProjectDetails}
                            editProjectDetailQty={editProjectDetailQty}
                            removeDetailFromProject={removeDetailFromProject}
                            editProjectDetailVendorIdentifier={editProjectDetailVendorIdentifier}
                            editProjectFeature={editProjectFeature}
                            eurExchangeRate={eurExchangeRate}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}
